import { api } from './authService';

const MESSAGE_TEMPLATES_ENDPOINT = '/acs/message-templates/';

class MessageTemplateService {
    static async getTemplates(filters = {}) {
        try {
            const params = new URLSearchParams();
            
            if (filters.account) {
                params.append('account', filters.account);
            }
            
            if (filters.scope === 'system') {
                params.append('system_only', 'true');
            }
            
            if (filters.category) {
                params.append('category', filters.category);
            }
            
            if (filters.channel) {
                params.append('channel', filters.channel);
            }

            const response = await api.get(`${MESSAGE_TEMPLATES_ENDPOINT}?${params.toString()}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching templates:', error);
            throw error;
        }
    }

    static async getTemplate(id) {
        try {
            const response = await api.get(`${MESSAGE_TEMPLATES_ENDPOINT}${id}/`);
            return response.data;
        } catch (error) {
            console.error('Error fetching template:', error);
            throw error;
        }
    }

    static async createTemplate(templateData) {
        try {
            const response = await api.post(MESSAGE_TEMPLATES_ENDPOINT, templateData);
            return response.data;
        } catch (error) {
            console.error('Error creating template:', error);
            throw error;
        }
    }

    static async updateTemplate(templateId, templateData) {
        try {
            const response = await api.put(`${MESSAGE_TEMPLATES_ENDPOINT}${templateId}/`, templateData);
            return response.data;
        } catch (error) {
            console.error('Error updating template:', error);
            throw error;
        }
    }

    static async deleteTemplate(id) {
        try {
            await api.delete(`${MESSAGE_TEMPLATES_ENDPOINT}${id}/`);
        } catch (error) {
            console.error('Error deleting template:', error);
            throw error;
        }
    }

    static async previewTemplate(previewData) {
        try {
            const response = await api.post(`${MESSAGE_TEMPLATES_ENDPOINT}preview/`, previewData);
            return response.data;
        } catch (error) {
            console.error('Error previewing template:', error);
            throw error;
        }
    }

    static async getAvailableVariables() {
        try {
            const response = await api.get(`${MESSAGE_TEMPLATES_ENDPOINT}variables/`);
            return response.data;
        } catch (error) {
            console.error('Error fetching available variables:', error);
            throw error;
        }
    }
}

export default MessageTemplateService; 